// extracted by mini-css-extract-plugin
module.exports = {"card":"_9962","title":"_10630"};